'use strict';

function productSliderFadeIn() {
    const offset = $(window).height() / 2;
    const $sliderHolder = $('.js-product-slider-holder');
    const sliderHolderRect = $sliderHolder[0].getBoundingClientRect().top;


    if (sliderHolderRect < offset) {
        if (!$sliderHolder.hasClass('fadein')) {
            $sliderHolder.addClass('fadein');
        }
    }
}

function toggleReadMoreText() {
    const $shortText = $('.step-intro').find('.js-slider-text-short');
    const $longText = $('.step-intro').find('.js-slider-text-long');

    $(document).on('click', '.js-slider-toggle', function() {
        $longText.toggle();
        $shortText.toggle();
    });
}

/**
 * @description Initialize block
 */
function initBlock() {
    productSliderFadeIn();
    toggleReadMoreText();
}

/**
 * @description Initialize event handlers for the product slider block
 */
function initializeEvents() {
    $(window).scroll(function () {
        productSliderFadeIn();
    });
}

const productSlider = {
    init: function() {
        // if product slider exists, init
        if ($('.js-product-slider-holder').length > 0){
            initBlock();
            initializeEvents();

            // init sticky out of stock bar
            const outOfStock = require('./pages/product/outOfStock');

            outOfStock.init();
        }
    }
};

module.exports = productSlider;
